export default __webpack_public_path__ + "static/media/128x128.c160f496.jpg";